<template>
  <div v-bind="$attrs" v-on="$listeners" class="compact-events-list">
    <div class="my-2 w-100 text-center" v-if="loading">
      <HMSpinner />
    </div>
    <CompactEvent
      v-else
      v-for="event in limitedEvents"
      :key="event.id"
      :event="event"
      :highlight="event === nextEvent"
      :displayRegistrations="displayRegistrations"
      @click="eventClicked"
    />
    <div v-if="displayMoreEventsLink && showMoreEventsLink" class="mt-2">
      <i class="fa fa-calendar-o c-brand-color mr-2"></i>
      <router-link
        class="undecorated-router-link"
        :to="{
          name: 'studio-calendar',
        }"
      >
        {{ $t('EVENTS.BUTTON.SHOW_ALL_UPCOMING_EVENTS') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CompactEvent from '@/web/components/events/CompactEvent';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import HMSpinner from '@/web/components/common/HMSpinner';

export default Vue.extend({
  name: 'CompactEventsList',
  components: {
    HMSpinner,
    CompactEvent,
  },
  props: {
    events: {
      type: Array,
    },
    nextEvent: {
      type: Object,
    },
    openEventDetailsOnClick: {
      type: Boolean,
      default: true,
    },
    maxEvents: {
      type: Number,
      default: 5,
    },
    showMoreEventsLink: {
      type: Boolean,
      default: false,
    },
    displayRegistrations: {
      type: Boolean,
      default: false,
    },
    openInNewWindow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    limitedEvents() {
      if (this.maxEvents === 0) return this.events;
      return this.events.slice(0, this.maxEvents);
    },
    displayMoreEventsLink() {
      return this.events.length > this.maxEvents;
    },
  },
  methods: {
    eventClicked(event) {
      if (this.openInNewWindow) {
        const routeData = this.$router.resolve({
          name: 'studio-event-details',
          params: {
            studio_url: getStudioURL(this.$route),
            event_id: event.id,
          },
        });
        window.open(routeData.href, '_blank');
      } else if (this.openEventDetailsOnClick) {
        this.$router.push({
          name: 'studio-event-details',
          params: {
            studio_url: getStudioURL(this.$route),
            event_id: event.id,
          },
        });
      } else {
        this.$emit('onEventClick', event);
      }
    },
  },
});
</script>

<style scoped></style>
